// @ts-ignore
import MimeLookup from 'mime-lookup'
import mimeDb from 'mime-db'

const mime = new MimeLookup(mimeDb)

export default mime
